import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import s from './MapNoteSheet.module.scss';

const MapNoteStatusButton = props => (
    <div className={s.statusButton}>
        <button className={classNames(s.button, s.statusButtonStyling, props.status === 'open' ? s.open : s.resolved)} type="button" onClick={props.onStatusChange}>
            <div className={classNames(s.icon, 'icon-tick')} />
            <div className={s.label}>{props.status === 'open' ? 'Resolve Note' : 'Resolved'}</div>
        </button>
    </div>
);

MapNoteStatusButton.propTypes = {
    status: PropTypes.string.isRequired,
    onStatusChange: PropTypes.func.isRequired,
};

export default MapNoteStatusButton;
